import React from 'react'
import { Calendar as ReactCalendar } from 'react-big-calendar'

import FindTutorClassBannerCalendarHeader from './FindTutorClassBannerCalendarHeader'
import FindTutorClassBannerCalendarTimeSlot from './FindTutorClassBannerCalendarTimeSlot'
import { Icon } from '../../../components/UI'

import { localizer } from '../../../constants'

import './findTutorClassBannerCalendar.css'

const FindTutorClassBannerCalendar = ({ classBanner, heightOfCalendar, onCalendar }) => {
  return (
    <div className="relative flex items-center justify-center ml-[10px] group/calendar">
      <ReactCalendar
        className="metaverse-calendar find-tutor-class-banner-calendar !min-h-[295px] w-[306px] rounded-[10px] animate-appearFindTutorCalendar text-primary-100 bg-[#FFE0CA]"
        defaultView="week"
        startAccessor="start"
        endAccessor="end"
        localizer={localizer}
        defaultDate={new Date()}
        style={{
          height: `${heightOfCalendar}px`,
          opacity: heightOfCalendar ? 1 : 0,
          transition: 'opacity .2s ease',
        }}
        components={{
          toolbar: () => null,
          timeSlotWrapper: (props) => (
            <FindTutorClassBannerCalendarTimeSlot {...props} slots={classBanner.available_slots} />
          ),
          header: FindTutorClassBannerCalendarHeader,
        }}
        timeslots={1}
        step={60}
      />

      <div className="opacity-0 group-hover/calendar:!opacity-100 absolute top-0 bottom-0 left-0 right-0 bg-[#00000066] rounded-[10px] flex items-center justify-center transition-opacity duration-200 ease">
        <button
          className="rounded-[8px] bg-[#FDFDFD] w-[225px] h-[48px] shadow-xs-dark flex items-center justify-center transition-colors duration-200 ease"
          onClick={() => onCalendar(classBanner)}
        >
          <Icon name="calendar-line" color="#F79009" className="mr-[8px] w-[24px] h-[24px]" />

          <span className="text-sm font-medium text-primary-100">See Complete Schedule</span>
        </button>
      </div>
    </div>
  )
}

export default FindTutorClassBannerCalendar
